import styled from 'styled-components';

export const SelectedItemsText = styled.span`
  font-size: 14px;
`;
